import React, { useState } from "react";
import { Btn, FormInput } from "../../utils/utils";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "iconsax-react";
import logo from "../../assets/home-logo.png";
import tick from "../../assets/big-tick.png";
import "./auth.css";
import { AxiosPost } from "../../api/api";

const NewPassComp = () => {
  const url = "auth/reset-password/reset/";
  const navigate = useNavigate();
  const [isComplete, setIsComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const email = localStorage.getItem("reset-email");
  const otp = localStorage.getItem("otp");

  const handleData = (e) => {
    setPasswordErr("");
    setPassword(e.target.value);
  }

  const dataObj = {
    email: email,
    code: otp,
    password: password
  }

  const clickReset = () => {
    setIsLoading(true);
    AxiosPost(url, dataObj).then((res) => {
      // console.log(res);      
      setIsComplete(true);
      localStorage.removeItem("otp");
      localStorage.removeItem("email");
      setTimeout(() => {
        navigate("/auth/signin");
      }, 3000);
      setIsLoading(false);
    }).catch((err) => {
      // console.log(err.response);
      setPasswordErr(err?.response?.data?.errors[0].error);
      setIsLoading(false);
    })
  };

  return (
    <div className="forgot new-pass">
      <img src={logo} alt="logo" />
      {!isComplete && (
        <div className="forgot-form">
          <h3>Set new Password</h3>
          <p>Must be at least 8 characters</p>
          <FormInput label={"New Password"} placeholder="******" isPassword err={passwordErr} changeInput={handleData} />
          {/* <FormInput
            label={"Confirm New Password"}
            placeholder="******"
            isPassword
          /> */}
          <div className="forgot-btn_cont">
            <Btn
              btnClass={"home-btn"}
              btnText={"Reset Password"}
              btnClick={clickReset}
              btnWidth={"100%"}
              loading={isLoading}
            />
          </div>
          <Link to={"/auth/signin"} style={{ textDecoration: "none" }}>
            <div className="go-back">
              <ArrowLeft color="#444" size={24} />
              <p>Back to Login</p>
            </div>
          </Link>
        </div>
      )}
      {isComplete && (
        <div className="forgot-form">
          <h3>All Done</h3>
          <p>
            Your password has been reset <br />
            sucessfully
          </p>
          <img className="forgot-img" src={tick} alt="complete" />
          {/* <div className="forgot-btn_cont">
            <Btn
              btnClass={"home-btn"}
              btnText={"Homepage"}
              btnLink={"/"}
              btnWidth={"100%"}
            />
          </div> */}
        </div>
      )}
    </div>
  );
};

export default NewPassComp;
